import { useRedirect } from 'core/hooks/useRedirect';
import { Redirect } from 'react-router';

export const RedirectHandler: React.FC = ({ children }) => {
    const { redirect } = useRedirect();

    if (redirect) {
        return <Redirect to={redirect} />;
    }

    return <>{children}</>;
};
